import * as React from 'react';
import { useSelector } from 'react-redux';

import { PlacesNearby } from '../../components/PlacesNearby';
import { getPlacesNearby } from '../../selectors/newbuilding';

export function PlacesNearbyContainer() {
  const placesNearby = useSelector(getPlacesNearby);

  if (!placesNearby || placesNearby.length === 0) {
    return null;
  }

  return <PlacesNearby placesNearby={placesNearby} />;
}
